import React from "react";
import { Form } from "react-final-form";
import { Box, Button } from "@mui/material";

import { LoadingButton } from "ui";

import { TextField } from "fond/form/fields";
import { AnyObject } from "fond/types";
import { generateUnusedName } from "fond/utils/naming";
import { required } from "fond/utils/validation";
import { Modal } from "fond/widgets";

import { SetupContainer } from "../../import/modal/ImportModal/ImportModal.styles";

interface IFormData {
  Name: string;
}

interface IProps {
  /**
   * Callback function to handle the onClose of the modal
   */
  onClose(): void;
  /**
   * Callback function for when the form is submitted
   */
  onSubmit(name: string): void;
  /**
   * Optional array of existing version names to check against
   */
  versionNames?: string[];
}

const CreateScenarioModal: React.FC<IProps> = ({ onClose, onSubmit, versionNames }: IProps) => {
  let submit: (event?: Partial<Pick<React.SyntheticEvent, "preventDefault" | "stopPropagation">>) => Promise<AnyObject | undefined> | undefined;
  /**
   * Callback function for the Create button within the modal actions
   */
  const handleOnClick = (event: React.MouseEvent<EventTarget>) => {
    // Submits the React-Final-Form (which handles validation & calling onSubmit is validation passes)
    submit();
  };
  /**
   * On submit function called when the form is submitted and valid
   */
  const handleOnSubmit = async ({ Name }: IFormData) => {
    onSubmit(Name);
  };

  return (
    <Modal
      open
      header="Create Scenario"
      data-testid="create-scenario-modal"
      content={
        <Box>
          <Form<IFormData>
            onSubmit={handleOnSubmit}
            render={({ handleSubmit }) => {
              submit = handleSubmit;
              return (
                <form onSubmit={handleSubmit}>
                  <SetupContainer>
                    <Box width={424}>
                      <TextField
                        inputProps={{ "data-testid": "new-scenario-name-input" }}
                        autoFocus
                        name="Name"
                        defaultValue={generateUnusedName("Scenario", versionNames || [])}
                        required
                        label="Name"
                        fullWidth
                        validate={required}
                      />
                    </Box>
                  </SetupContainer>
                </form>
              );
            }}
          />
        </Box>
      }
      actions={
        <>
          <Button data-testid="create-scenario-cancel-button" color="primary" onClick={onClose} sx={{ marginRight: 1 }}>
            Cancel
          </Button>
          <LoadingButton data-testid="create-scenario-save-button" color="primary" onClick={handleOnClick}>
            Submit
          </LoadingButton>
        </>
      }
    />
  );
};

export default CreateScenarioModal;
